import React, { useCallback, useEffect, useState } from "react";
import "../../styles/faculty-details/main.css";
import { useParams } from "react-router-dom";
import { getAllDepartmentById } from "../../Services/AllAPIs";
import "@fancyapps/ui/dist/fancybox/fancybox.css"; // Correct path for FancyBox 4
import { Fancybox } from "@fancyapps/ui";
import LoadingSpinner from "../LoadingSpinner";

const Main = () => {
    const [activeTab, setActiveTab] = useState("tabsClickBtn");

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    const [loader, setLoader] = useState(true);
    const [department, setDepartment] = useState(null);
    const [error, setError] = useState(null);
    const { id } = useParams();

    // Function to fetch faculty data by id, memoized with useCallback
    const getFacultyDetailsById = useCallback(() => {
        getAllDepartmentById(id)
            .then((res) => {
                // console.log("------->", res.data);
                setDepartment(res.data);
                setLoader(false);
            })
            .catch((error) => {
                console.error("Error fetching faculty:", error);
                setError("An error occurred while fetching faculty data.");
                setLoader(false);
            });
    }, [id]);

    useEffect(() => {
        Fancybox.bind("[data-fancybox='gallery']", {
            infinite: false,
            loop: true,
        });

        getFacultyDetailsById();
    }, [id, getFacultyDetailsById]); // Adding getFaculty and getFacultyById to the dependency array

    const facilitiesContent = department?.html_tabs?.[0]?.facilities;
    const jobPlacementContent = department?.html_tabs?.[0]?.job_placement;
    const gallery = department?.gallery || [];
    const researchPublicationsContent =
        department?.html_tabs?.[0]?.research_publications;
    const achievementsContent = department?.html_tabs?.[0]?.achievements;
    const timetableContent = department?.html_tabs?.[0]?.timetable;


    // Function to format date as DD/MM/YYYY
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[date.getMonth()];
    
        return `${day} ${month}`;
    };
    

    if (loader) {
        return <LoadingSpinner />;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div id="facultyDetailsMain">
            <div className="faculty-details mb-5">
                <div className="container border rounded">
                    <h3 className="my-heading text-left pt-5 pb-4">
                        {" "}
                        DEPARTMENT OF {department.name}
                    </h3>
                    <ul className="nav nav-tabs">
                        <li className="nav-item about-tab">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn")}
                            >
                                About
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn1" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn1")}
                            >
                                Programmes/Courses
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn2" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn2")}
                            >
                                Faculty
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn3" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn3")}
                            >
                                Syllabus
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn4" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn4")}
                            >
                                Facilities
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn5" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn5")}
                            >
                                Job/Placement
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn6" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn6")}
                            >
                                Gallery
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn7" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn7")}
                            >
                                Research &amp; Publication
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn8" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn8")}
                            >
                                Achievements
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "tabsClickBtn9" ? "active" : ""
                                    }`}
                                onClick={() => handleTabClick("tabsClickBtn9")}
                            >
                                Time Table
                            </button>
                        </li>
                    </ul>

                    <div className="tab-content">
                        <div
                            id="about"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn" ? "show active" : ""
                                }`}
                        >
                            <div className="row main-400">
                                <div
                                    className="col-md-4 col-12 photo"
                                    style={{
                                        borderTopLeftRadius: 25,
                                        borderBottomLeftRadius: 25,
                                        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                                        position: "relative",
                                        height: "100%",
                                    }}
                                >
                                    {/* Faculty Image */}
                                    <img
                                        style={{ height: "90%", position: "relative" }}
                                        src={
                                            department?.faculty?.[0]?.employee?.[0]?.image ||
                                            "/path/to/default-image.jpg"
                                        }
                                        alt={
                                            department?.faculty?.[0]?.employee?.[0]?.name || "Faculty"
                                        }
                                        className="img-fluid"
                                    />
                                </div>

                                <div className="col-md-8 col-12 content">
                                    <div className="row">
                                        {/* Department Overview */}
                                        <div className="col overview overview-content down">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        department?.html_tabs?.[0]?.about ||
                                                        "No information available.",
                                                }}
                                            />
                                        </div>

                                        {/* Latest Updates Section */}
                                        <div className="col latest-updates latest-updates-content">
                                            <div className="latest-updates-heading">
                                                Latest Updates
                                            </div>
                                            {department?.news?.length > 0 ? (
                                                department.news.map((update, idx) => (
                                                    <div key={idx}>
                                                        <p className="date">{formatDate(update.created_at)}</p>
                                                        <p>
                                                            <a
                                                                href={update.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="pdf-link"
                                                            >
                                                                {update.title}
                                                            </a>
                                                        </p>
                                                        <hr />
                                                    </div>
                                                ))
                                            ) : (
                                                <p>No updates available.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            id="programmes"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn1" ? "show active" : ""
                                }`}
                        >
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="">
                                        <h3>Programme/ Courses</h3>
                                        <p>
                                            The department is currently offering the following
                                            programmes of study:
                                        </p>
                                        <h4>&nbsp;</h4>

                                        {/* Loop through courses dynamically */}
                                        {department?.courses?.length > 0 ? (
                                            department.courses.map((course, idx) => (
                                                <div key={idx}>
                                                    <h5>{course.name}</h5>
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>Details</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {/* About Programme */}
                                                            <tr>
                                                                <td>
                                                                    <strong>About Programme:</strong>
                                                                    <br />
                                                                    {course.about ? course.about.replace(/<\/?p>/g, '') :"No information available."}
                                                                </td>
                                                            </tr>
                                                            {/* Duration */}
                                                            <tr>
                                                                <td>
                                                                    <strong>Duration:</strong>
                                                                    <br />
                                                                   {course.duration ? course.duration.replace(/<\/?p>/g, '') : "Not specified"}
                                                                </td>
                                                            </tr>
                                                            {/* Number of Seats */}
                                                            <tr>
                                                                <td>
                                                                    <strong>Number of Seats:</strong>
                                                                    <br />
                                                                    {course.seats || "Not specified"}
                                                                </td>
                                                            </tr>
                                                            {/* Nature/Type */}
                                                            <tr>
                                                                <td>
                                                                    <strong>Nature/Type:</strong>
                                                                    <br />
                                                                    {course.nature_type ? course.nature_type.replace(/<\/?p>/g, '') :"Not specified"}
                                                                </td>
                                                            </tr>
                                                            {/* Eligibility Conditions */}
                                                            <tr>
                                                                <td>
                                                                    <strong>Eligibility Conditions:</strong>
                                                                    <br />
                                                                    {course.eligibility ? course.eligibility.replace(/<\/?p>/g, '') :"Not specified"}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ))
                                        ) : (
                                            <p>No programmes available.</p> // Fallback message if no courses are available
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            id="faculty"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn2" ? "show active" : ""
                                }`}
                        >
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="faculty">
                                        <h3 className="my-heading">Faculty</h3>

                                        {/* Check if there is faculty data */}
                                        {department?.faculty?.length > 0 ? (
                                            <>
                                                {/* Loop through faculty groups */}
                                                {department.faculty.map((facultyGroup, idx) => (
                                                    <div key={idx}>
                                                        {/* Render Designation Name */}
                                                        <p className="mt-3 text-uppercase">
                                                            {facultyGroup.designation_name}
                                                        </p>

                                                        {/* Loop through the employees in the current faculty group */}
                                                        <div className="more-boxes row">
                                                            {facultyGroup.employee.map((employee, empIdx) => (
                                                                <div
                                                                    className="col-md-4 col-12 box-faculty"
                                                                    key={empIdx}
                                                                >
                                                                    <div className="image">
                                                                        {/* Render Faculty Image */}
                                                                        <img
                                                                            src={
                                                                                employee.image || "default-image-url"
                                                                            } // Fallback image if no image is provided
                                                                            alt={employee.name || "Faculty Member"}
                                                                            className="img-fluid"
                                                                        />
                                                                    </div>
                                                                    <div className="content">
                                                                        {/* Render Faculty Name and Degree */}
                                                                        <h1 style={{ lineHeight: "1.2" }}>
                                                                            {employee.name}
                                                                        </h1>
                                                                        <p style={{ lineHeight: "1.2" }}>
                                                                            {employee.degree}
                                                                        </p>
                                                                        {/* Render Resume Link */}
                                                                        <a
                                                                            href={employee.resume || "#"}
                                                                            target="_blank"
                                                                            className="pdf-link"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            {employee.resume
                                                                                ? "View Resume"
                                                                                : "No Resume Available"}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        ) : (
                                            <p>No faculty data available.</p> // Fallback if no faculty data exists
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            id="syllabus"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn3" ? "show active" : ""
                                }`}
                        >
                            <div className="row">
                                <div
                                    className="col-md-12 col-12"
                                    style={{ overflow: "scroll" }}
                                >
                                    <div>
                                        <h3>Syllabus</h3>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Programme Name</th>
                                                    <th>Download New/ Revised Syllabus</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {department &&
                                                    department.syllabus &&
                                                    department.syllabus.length > 0 ? (
                                                    department.syllabus.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.name}</td>
                                                            <td>
                                                                <button className="btn btn-primary btn-download">
                                                                    <a
                                                                        href={item.url}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        Download
                                                                    </a>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="2">No syllabus available.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            id="faculties"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn4" ? "show active" : ""
                                }`}
                        >
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="" style={{ overflow: "scroll" }}>
                                        <h3>Facilities</h3>

                                        {/* Check if there are facilities to display */}
                                        {facilitiesContent ? (
                                            <div
                                                className="facilities-content"
                                                dangerouslySetInnerHTML={{ __html: facilitiesContent }}
                                            />
                                        ) : (
                                            <p>No facilities information available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            id="placement"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn5" ? "show active" : ""
                                }`}
                            style={{ overflow: "scroll" }}
                        >
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="">
                                        <h3>Job/Placement</h3>

                                        {/* Check if job placement content is available */}
                                        {jobPlacementContent ? (
                                            <div
                                                className="job-placement-content"
                                                dangerouslySetInnerHTML={{
                                                    __html: jobPlacementContent,
                                                }}
                                            />
                                        ) : (
                                            <p>No job placement information available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            id="gallery"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn6" ? "show active" : ""
                                }`}
                        >
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    {/* Check if gallery data exists */}
                                    {gallery && gallery.length > 0 ? (
                                        gallery.map((item, index) => (
                                            <div className="tz-gallery">
                                                <div key={index} className="gallery-section">
                                                    {/* Render Title and Subtitle */}
                                                    <h4 style={{ textTransform: "capitalize" }}>
                                                        {item.title}
                                                    </h4>
                                                    <p>{item.subtitle}</p>

                                                    {/* Render Images */}
                                                    <div className="row">
                                                        {item.images && item.images.length > 0 ? (
                                                            item.images.map((image, imageIndex) => (
                                                                <div
                                                                    key={imageIndex}
                                                                    className="col-sm-12 col-md-4"
                                                                >
                                                                    <a
                                                                        className="lightbox"
                                                                        href={image.url}
                                                                        data-fancybox="gallery"
                                                                    >
                                                                        <img
                                                                            src={image.url}
                                                                            alt={`Gallery ${index + 1} - ${imageIndex + 1
                                                                                }`}
                                                                            className="img-fluid"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>No images available.</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No gallery available.</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div
                            id="research"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn7" ? "show active" : ""
                                }`}
                        >
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <h3>Research &amp; Publications</h3>

                                    <div className="container" style={{ overflow: "scroll" }}>
                                        {/* Check if there are research publications to display */}
                                        {researchPublicationsContent ? (
                                            <div
                                                className="research-publications-content"
                                                dangerouslySetInnerHTML={{
                                                    __html: researchPublicationsContent,
                                                }}
                                            />
                                        ) : (
                                            <p>No research publications available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            id="achievements"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn8" ? "show active" : ""
                                }`}
                        >
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <h3>Achievements</h3>

                                    <div className="container" style={{ overflow: "scroll" }}>
                                        {/* Check if there are achievements to display */}
                                        {achievementsContent ? (
                                            <div
                                                className="achievements-content"
                                                dangerouslySetInnerHTML={{
                                                    __html: achievementsContent,
                                                }}
                                            />
                                        ) : (
                                            <p>No achievements information available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            id="timetable"
                            className={`tab-pane fade ${activeTab === "tabsClickBtn9" ? "show active" : ""
                                }`}
                        >
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <h3>Time Table</h3>

                                    <div className="container" style={{ overflow: "scroll" }}>
                                        {/* Check if there is timetable content to display */}
                                        {timetableContent ? (
                                            <div
                                                className="timetable-content"
                                                dangerouslySetInnerHTML={{ __html: timetableContent }}
                                            />
                                        ) : (
                                            <p>No timetable information available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
